<template>
  <div class="col-xl-12 pr-4">
    <container-headline
      :headline="$t('global.persons')"
      :col="3"
    ></container-headline>
    <div class="row mb-3">
      <div class="col-xl-12 block br-t-l-0">
        <div class="eingabe-panel-kopf p-3">
          <div class="row">
            <div class="col-xl-6">
              <div class="row">
                <div class="col-xl-12">
                  <single-select-person
                    id="person"
                    :person="notiz.person"
                    :label="$t('global.person')"
                    :allowOpen="berechtigungen.m_geschaeftspartner.read"
                    :editable="editable"
                    :required="false"
                    @confirmed="setPerson"
                  />
                </div>
              </div>
            </div>

            <div class="col-xl-3">
              <single-select-person
                id="kontaktdurch"
                :person="notiz.kontakt_durch"
                :label="$t('global.contactby')"
                :allowOpen="berechtigungen.m_geschaeftspartner.read"
                :editable="editable"
                :required="false"
                :rollen="filterMitarbeitende"
                @confirmed="setKontaktDurch"
              />
            </div>
            <div class="col-xl-6">
              <div class="row">
                <div class="col-xl-12">
                  <single-select-firma
                    id="firma"
                    :firma="notiz.firmen?.[0]"
                    :label="$t('global.company')"
                    :allowOpen="berechtigungen.m_geschaeftspartner.read"
                    :editable="editable"
                    :required="false"
                    @confirmed="setKontaktFirma"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import ContainerHeadline from "@/components/ContainerHeadline";

import SingleSelectPerson from "@/components/global/SingleSelectPerson.vue";
import SingleSelectFirma from "@/components/global/SingleSelectFirma.vue";

import store from "@/store";

export default {
  name: "NotizPersonen",
  components: {
    ContainerHeadline,
    SingleSelectPerson,
    SingleSelectFirma,
  },
  mixins: [],
  store,
  props: {
    notiz: {
      type: Object,
      required: true,
    },
    editable: {
      type: Boolean,
      default: true,
    },
    navbarTitel: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      filterMitarbeitende: this.$CONST("ROLLEN").MITARBEITER,
    };
  },
  computed: {},
  watch: {},

  created() {},

  methods: {
    setKontaktFirma(firma) {
      if (!this.notiz.person?.id) {
        this.notiz.firmen = [firma];
      } else {
        this.$notify({
          type: "warning",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.notealreadylinkedtoperson"),
        });
      }
    },

    setKontaktDurch(person) {
      this.notiz.kontakt_durch = person; 
    },

    setPerson(person) {
      if (!this.notiz.firmen?.[0]?.id) {
        this.notiz.person = person;
      } else {
        this.$notify({
          type: "warning",
          title: this.$t("global.actionfailed"),
          text: this.$t("global.notealreadylinkedtocompany"),
        });
      }
    },
  },
}  
</script>

<style>
</style>
